export default __webpack_public_path__ + "0523840f5873ee3422482331552c039d.png";